import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';
import { IRecentTuition } from '../../../models/payments.model';
import { ApexOptions } from 'apexcharts';

interface IProps {
  data: IRecentTuition[];
}

const ColumnChart: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  const series: ApexOptions['series'] = [
    {
      name: t('class.dashboard.column6'),
      data: data.map((value) => value.tuition),
      color : '#8bd0db'
    },
    {
      name: t('class.dashboard.column7'),
      data: data.map((value) => value.onlineTuition),
      color : '#14c7e657'
    },
    {
      name: t('class.dashboard.column8'),
      data: data.map((value) => value.shuttleTuition),
      color : '#cde9ee'
    },
    {
      name: t('dashboard.text.4'),
      data: data.map((value) => value.examTuition),
      color : '#697480'
    },
    {
      name: t('dashboard.text.5'),
      data: data.map((value) => value.alexTuition),
      color : '#979fa8'
    },
    {
      name: t('dashboard.text.7'),
      data: data.map((value) => value.specialClassTuition),
      color : '#c0c6cb'
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: { show: false },
      fontFamily: 'Roboto'
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
            fontFamily: 'Roboto'
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          total: {
            enabled: false,
          },
        },
      },
    },
    xaxis: {
      type: 'category',
      categories: data.map((value) => value.dateStr),
    },
    legend: {
      position: 'top',
    },
    dataLabels: { enabled: false },
    fill: {
      opacity: 1
    },
  };

  return <Chart series={series} options={options} type="bar" height={350} />;
};

export default ColumnChart;
